// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import commonCss from './assets/css/common.css'
import commonJs from './assets/js/common'
import './assets/css/iconfont.css'
import page from './components/myComponents/page'
// import cander from './components/myComponents/cander'
// import canderYM from './components/myComponents/canderYearMonth'
import canderSFM from './components/myComponents/canderSFM'
import axiox from './assets/js/axios.js'
import VueI18n from 'vue-i18n'
import myCharts from './assets/js/myCharts.js'
import babelpolyfill from 'babel-polyfill'
import multipleSelect from './components/myComponents/multipleSelect'
import hospitalSelect from './components/myComponents/hospitalSelect'
import tsName from './components/myComponents/tsName'
import asmTd from './components/myComponents/asmTd'
import mktTd from './components/myComponents/mktTd'
import reason from './components/myComponents/reason'
import mktReason from './components/myComponents/mktReason'
import rejectComment from './components/myComponents/rejectComment'
import showReason from './components/myComponents/showReason'
import dialogArea from './components/myComponents/dialog'
import BUDDialogArea from './components/myComponents/BUDDialog'
import pubilshSet from './assets/js/pubilshSet'
Vue.use(VueI18n)
Vue.use(commonCss)
Vue.use(myCharts)
Vue.use(babelpolyfill)
Vue.component('page', page)
Vue.component('canderSFM', canderSFM)
Vue.component('allSelect', multipleSelect)
Vue.component('hospitalSelect', hospitalSelect)
Vue.component('tsName', tsName)
Vue.component('editCom', asmTd)
Vue.component('mktEdit', mktTd)
Vue.component('reason', reason)
Vue.component('mktReason', mktReason)
Vue.component('rejectComment', rejectComment)
Vue.component('showReason', showReason)
Vue.component('dialogArea', dialogArea)
Vue.component('BUDDialogArea', BUDDialogArea)
Vue.prototype.$commonJs = commonJs
Vue.prototype.$axiox = axiox
Vue.prototype.$baseUrl = pubilshSet.baseUrl
// 判断是IE几
let IENum = -1
let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
console.log(userAgent)
let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
let isChrome = userAgent.indexOf('Chrome') > -1 // 判断是不是谷歌
let isiPad = userAgent.indexOf('iPad') > -1 // 判断是不是ipad
let isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
if (isIE) {
  let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
  reIE.test(userAgent)
  let fIEVersion = parseFloat(RegExp['$1'])
  if (fIEVersion === 7) {
    IENum = 7
  } else if (fIEVersion === 8) {
    IENum = 8
  } else if (fIEVersion === 9) {
    IENum = 9
  } else if (fIEVersion === 10) {
    IENum = 10
  } else {
    IENum = 6 // IE版本<=7
  }
} else if (isEdge) {
  IENum = 'edge' // edge
} else if (isIE11) {
  IENum = 11 // IE11
} else {
  if (isChrome) {
    IENum = -1 // 是谷歌浏览器内核
  } else {
    IENum = -2 // 不是ie浏览器且不是谷歌
  }
}
Vue.prototype.$IENum = IENum
Vue.prototype.$isiPad = isiPad

const i18n = new VueI18n({
  locale: window.localStorage.getItem('language') || 'zh-CN',
  messages: {
    'zh-CN': require('@/assets/js/lang/CN.json'),
    'en-US': require('@/assets/js/lang/EN.json')
  }
})
let vm = new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})
Vue.use({
  vm
})
// if (window.location.href.indexOf('login') >= 0) {

//   // eslint-disable-next-line no-new
//   new Vue({
//     el: '#app',
//     router,
//     i18n,
//     components: { App },
//     template: '<App/>'
//   })
// } else {
//   // getUserInfo()
// }
// async function getUserInfo () {
//   let loginInfo = await axiox.asyncGet('/Login/userinfo')
//   let FinanceTeamList = await axiox.asyncGet('/api/financereview/FinanceTeamTodoSummaryInfo')
//   let AssistantList = await axiox.asyncGet('/api/DepartmentAssistantSubmit/TodoSummaryInfo')
//   let departAssistantList = await axiox.asyncGet('/api/DepartmentAssistantSubmit/DepartmentAssistantTodoSummaryInfo')
//   let MenuPermissions = await axiox.asyncGet('/api/authoritymenu/usermenus?userId=' + loginInfo.id)
//   let fatherMenuList = []
//   let childMenuList = []
//   for (let i = 0; i < MenuPermissions.length; i++) {
//     if (MenuPermissions[i].url) {
//       fatherMenuList.push(MenuPermissions[i].url)
//     }
//     if (MenuPermissions[i].childMenus) {
//       for (let j = 0; j < MenuPermissions[i].childMenus.length; j++) {
//         if (MenuPermissions[i].childMenus[j].url) {
//           childMenuList.push(MenuPermissions[i].childMenus[j].url)
//         }
//       }
//     }
//   }
//   console.log(fatherMenuList)
//   console.log(childMenuList)
//   if (fatherMenuList.length === 0 && childMenuList.length === 0) {
//     window.location.href = pubilshSet.baseUrl + '/ui/#/noPermission'
//   }
//   Vue.prototype.$loginInfo = loginInfo
//   Vue.prototype.$FinanceTeamList = FinanceTeamList
//   Vue.prototype.$AssistantList = AssistantList
//   Vue.prototype.$departAssistantList = departAssistantList
//   Vue.prototype.$fatherMenuList = fatherMenuList
//   Vue.prototype.$childMenuList = childMenuList
//   window.localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
//   window.localStorage.setItem('FinanceTeamList', JSON.stringify(FinanceTeamList))
//   window.localStorage.setItem('AssistantList', JSON.stringify(AssistantList))
//   window.localStorage.setItem('departAssistantList', JSON.stringify(departAssistantList))
//   // window.localStorage.setItem('MenuPermissions', JSON.stringify(MenuPermissions))
//   // eslint-disable-next-line no-new
//   new Vue({
//     el: '#app',
//     router,
//     i18n,
//     components: { App },
//     template: '<App/>'
//   })
// }



// WEBPACK FOOTER //
// ./src/main.js